import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  base: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    fontSize: '1.8em',
    fontWeight: 600,
    textTransform: 'uppercase',
    boxSizing: 'border-box'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/admintitlebar/AdminTitleBar.styles.js